/*custom js*/

//old version to be removed
document.addEventListener("DOMContentLoaded", () => {
  if (
    window.location.href.indexOf("likor") > -1 ||
    window.location.href.indexOf("grill-paket-variante-1") > -1 ||
    window.location.href.indexOf("grill-paket-variante-2") > -1
  ) {
    document.getElementById("agp__root").style.display = "block";
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.getElementById("agp__root").style.display = "none";
  var tagsElement = document.getElementById("product-tags");
  var judgemeTitle = document.getElementsByClassName("jdgm-carousel-title")[0];
  var judgemeText = document.getElementsByClassName(
    "jdgm-all-reviews-text__text"
  )[0];
  if (tagsElement) {
    var tags = tagsElement.getAttribute("data-tags");
    var tagsArray = tags.split(", ");
    if (tagsArray.includes("alcohol verification")) {
      document.getElementById("agp__root").style.display = "block";
    }
  }
  if (judgemeTitle) {
    judgemeTitle.classList.add("h1");
  }
  if (judgemeText) {
    setTimeout(function () {
      judgemeText.innerHTML = judgemeText.innerHTML.replace("out of", "von");
      judgemeText.innerHTML = judgemeText.innerHTML.replace("stars", "Sternen");
      judgemeText.innerHTML = judgemeText.innerHTML.replace("based on", "basierend auf");
      judgemeText.innerHTML = judgemeText.innerHTML.replace("reviews", "Bewertungen");
    }, 3000);
  }
});

setInterval(function() {
    document.querySelector('#CartDrawer-Checkout')?.removeAttribute('style');
}, 1000);